import { render } from "./ContactButton.vue?vue&type=template&id=7dfe447c&scoped=true"
import script from "./ContactButton.vue?vue&type=script&lang=js"
export * from "./ContactButton.vue?vue&type=script&lang=js"

import "./ContactButton.vue?vue&type=style&index=0&id=7dfe447c&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dfe447c"]])

export default __exports__